import { EmblaCarouselType } from 'embla-carousel';
import { useCallback } from 'react';

// Глобальный объект для отслеживания блокировки вложенных каруселей
const CarouselLock = {
  locked: false,
  setLocked: (value: boolean) => {
    CarouselLock.locked = value;
  },
  isLocked: () => CarouselLock.locked
};

/**
 * Хук для управления вложенными каруселями
 * Позволяет блокировать родительские карусели при взаимодействии с вложенными
 */
export function useNestedCarousel(isNested: boolean = false) {
  // Функция для контроля перетаскивания
  const watchDrag = useCallback(() => {
    if (!isNested) {
      return !CarouselLock.isLocked();
    }
    return true;
  }, [isNested]);

  // Настройка обработчиков для вложенных каруселей
  const setupNestedHandlers = useCallback(
    (emblaApi: EmblaCarouselType) => {
      if (!isNested) return;

      const handlePointerDown = () => {
        CarouselLock.setLocked(true);
      };

      const handlePointerUp = () => {
        CarouselLock.setLocked(false);
      };

      const handleDragStart = () => {
        CarouselLock.setLocked(true);
      };

      const handleDragEnd = () => {
        setTimeout(() => {
          CarouselLock.setLocked(false);
        }, 100);
      };

      emblaApi.on('pointerDown', handlePointerDown);
      emblaApi.on('pointerUp', handlePointerUp);
      emblaApi.on('select', handleDragStart);
      emblaApi.on('settle', handleDragEnd);

      // Добавляем обработчики touch событий для мобильных устройств
      const viewportElement = emblaApi.containerNode().parentElement;
      if (viewportElement) {
        const handleTouchStart = () => {
          CarouselLock.setLocked(true);
        };

        const handleTouchEnd = () => {
          setTimeout(() => {
            CarouselLock.setLocked(false);
          }, 200);
        };

        viewportElement.addEventListener('touchstart', handleTouchStart, {
          passive: true
        });
        viewportElement.addEventListener('touchend', handleTouchEnd, {
          passive: true
        });

        return () => {
          emblaApi.off('pointerDown', handlePointerDown);
          emblaApi.off('pointerUp', handlePointerUp);
          emblaApi.off('select', handleDragStart);
          emblaApi.off('settle', handleDragEnd);
          viewportElement.removeEventListener('touchstart', handleTouchStart);
          viewportElement.removeEventListener('touchend', handleTouchEnd);
        };
      }

      return () => {
        emblaApi.off('pointerDown', handlePointerDown);
        emblaApi.off('pointerUp', handlePointerUp);
        emblaApi.off('select', handleDragStart);
        emblaApi.off('settle', handleDragEnd);
      };
    },
    [isNested]
  );

  return { watchDrag, setupNestedHandlers };
}
